import events from "add-event-listener";
import Big from "big.js";
import areEqual from "fbjs/lib/areEqual";
import PropTypes from "prop-types";
import * as React from "react";
import ReactDOM from "react-dom";
import * as ReactRedux from "react-redux";
import {
    Button,
    CandyTooltip,
    Checkbox,
    ComboBox,
    Gapped,
    Hint,
    Input,
    Link,
    MenuItem,
    MenuSeparator,
    Modal,
    Radio,
    Toast,
} from "react-ui";

import {
    createAbsoluteFromMask,
    createAbsoluteFromTokens,
    createRelativeFromTokens,
    PathToken,
    PathTokens,
} from "../../../Common/ModelPath/ModelPath";
import { PathUtils } from "../Engine/Core/PathUtils/PathUtils";
import { KCLangRuntimeUtils } from "../../../Common/KCLangRuntimeUtils";
import { useLocalizeString } from "../Engine/Core/Localization/LocalizerContext";
import { Icon } from "../Controls/Icons/Icon";

import { customizationHelpers } from "./customizationHelpers";
import * as Controls from "./InjectableModules/InjectableControls";
import * as Engine from "./InjectableModules/InjectableEngineModules";
import { injectableHelpers } from "./InjectableModules/InjectableHelpers";

export const candyInjectableModules = {
    areEqual: areEqual,
    react: { ...React, PropTypes: PropTypes },
    reactDOM: ReactDOM,
    "add-event-listener": events,
    "react-redux": ReactRedux,
    "react-ui": {
        Button: Button,
        Input: Input,
        ComboBox: ComboBox,
        Gapped: Gapped,
        Hint: Hint,
        Tooltip: CandyTooltip,
        Icon: Icon,
        Link: Link,
        MenuSeparator: MenuSeparator,
        Radio: Radio,
        Toast: Toast,
        MenuItem: MenuItem,
        Checkbox: Checkbox,
        Modal: Modal,
    },
    Controls: Controls,
    Engine: Engine,
    Helpers: injectableHelpers,
    CustomizationHelpers: customizationHelpers,
    Big: Big,
    PathUtils: PathUtils,
    sp: (path: string) => createAbsoluteFromMask(path, PathTokens.current),
    ap: (path: PathToken[]) => createAbsoluteFromTokens(path),
    mp: (path: PathToken[]) => createRelativeFromTokens(path),
    each: PathTokens.each,
    current: PathTokens.current,
    kcLangUtils: new KCLangRuntimeUtils(),
    useLocalizeString: useLocalizeString,
};
